import { useEffect } from "react";
import { pageViewEvent } from "../services/adobeDataLayer";
import { DataLayerEvent, getValuesInLocalStorange } from "../services/lsq";

function ThankYou() {
  useEffect(() => {
    let pushToDataLayer = async () => {
      const resp = await getValuesInLocalStorange("userData");
      DataLayerEvent(
        resp?.email,
        resp?.mobile,
        "land_loan_ty_eligible",
        "",
        "",
        "",
        false
      );
    };
    pushToDataLayer();
    //Trigger ADL on Thank you page load
    pageViewEvent("thank you");
  }, []);
  return (
    <>
      <article className="thankyou_sec">
        <div className="tick">
          <img
            src={process.env.PUBLIC_URL + "/dist/img/tick.webp"}
            alt="tick"
            width="100"
            height="100"
            className="img-fluid"
          />
        </div>
        <div className="thankyou_txt">
          <p>
            Thank you for your interest in
            <br className="br1" /> ICICI Bank Land Loan. <br className="br2" />
            Our representative <br className="br3" />
            will get in touch with you from a number starting with 1600-XX-XXXX{" "}
          </p>
        </div>
      </article>
    </>
  );
}

export default ThankYou;
